import { defineComponent as _defineComponent } from 'vue'
import OzOverlay from '@@/library/v4/components/OzOverlay.vue'
import { useSurfaceUserContributorsStore } from '@@/pinia/surface_user_contributors'
import AvatarImage from '@@/vuecomponents/avatar_image.vue'
import { useKeyDown } from '@@/vuecomposables/key_down'
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceContributors',
  setup(__props) {

const surfaceUserContributorsStore = useSurfaceUserContributorsStore()
const { registeredPostAuthors, anonymousPostAuthors, totalPostAuthors } = storeToRefs(surfaceUserContributorsStore)

useKeyDown('Escape', surfaceUserContributorsStore.hideContributorsList)

onMounted(() => {
  surfaceUserContributorsStore.fetchPostAuthors()
})

return { __sfc: true,surfaceUserContributorsStore, registeredPostAuthors, anonymousPostAuthors, totalPostAuthors, OzOverlay, AvatarImage }
}

})